import React from 'react';

import ButtonPublic from '@shared/components/ui/ButtonPublic';
import { HERO_LEDE } from '../../constants';
import HeroPortalForm from '../HeroPortalForm';

import styles from './styles.module.css';

import { track } from '@/shared/analytics/track';
import { useGlobalSettings } from '@/shared/hooks/useGlobalSettings';

const handleBookACallClick = (): void => {
  track('book_a_call_clicked', { location: 'hero' });
};

const Hero: React.FC = () => {
  const { bookAMeetingUrl } = useGlobalSettings();

  return (
    <section className={styles.hero} id="top">
      <div className={styles.shell}>
        <div className={styles.grid}>
          <div className={styles.copy}>
            <h1 className={styles.headline}>
              <em>Resale-as-a-Service</em>
              <br />
              <span className={styles.headlineTag}>
                Powered by <span className={styles.underline}>ThredUp</span>.
                <br />
                Built around your brand.
              </span>
            </h1>

            <p className={styles.lede}>{HERO_LEDE}</p>

            <div className={styles.actions}>
              <ButtonPublic
                as="a"
                href={bookAMeetingUrl}
                target="_blank"
                variant="primary"
                onClick={handleBookACallClick}
              >
                Book a strategy call
              </ButtonPublic>
            </div>
          </div>

          <HeroPortalForm />
        </div>
      </div>
    </section>
  );
};

export default Hero;
